import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import GeocoderInput from '../../../../../../../../../shared/components/GeocoderInput';

import { Checkbox, TextInput } from 'hosman-material';

import { updateOnboardedUser } from '../../../../../../../../reducers/SellerApp/mandatesSlice';

const PersonalAddressInput = () => {
  const { user } = useSelector((state) => state.user);
  const { onboardedUser, errors } = useSelector((state) => state.sellerMandates);
  const [isChecked, setIsChecked] = useState(onboardedUser.physical_address_attributes !== null);
  const dispatch = useDispatch();

  useEffect(() => {
    setIsChecked(!!user.physical_address);
  }, [user.physical_address]);

  useEffect(() => {    
    if (isChecked || !onboardedUser.physical_address_attributes) return

    dispatch(updateOnboardedUser({ ...onboardedUser, physical_address_attributes: { id: onboardedUser.physical_address_attributes.id, _destroy: '1' }}));
  }, [isChecked]);

  const handleAddressChange = (addressObj) => {
    dispatch(updateOnboardedUser({
      ...onboardedUser,
      physical_address_attributes: {
        ...addressObj,
        additional_address: onboardedUser.physical_address_attributes?.additional_address
      }
    }));
  };

  return (
    <div className='flex flex-col gap-3'  data-testid='PersonalAddressInput'>
      <Checkbox
        label="Mon adresse personnelle diffère de l'adresse du bien que je vends."
        isChecked={isChecked}
        name='personal_address'
        onChange={() => setIsChecked(prev => !prev)}
      />

      {isChecked &&
        <div>
          <p className='font-semibold text-ih-indigo mb-3'>Adresse postale</p>
          <div className='grid gap-5'>
            <GeocoderInput name='address' value={onboardedUser.physical_address_attributes?.address} onChange={handleAddressChange} errors={errors} />

            <TextInput
              label="Complément d'adresse"
              name='additional_address'
              value={onboardedUser.physical_address_attributes?.additional_address || ''}
              onChange={(e) =>
                dispatch(updateOnboardedUser({
                  ...onboardedUser,
                  physical_address_attributes: { ...onboardedUser.physical_address_attributes, additional_address: e.target.value }
                }))
              }
            />
          </div>
        </div>
      }
    </div>
  );
}

export default PersonalAddressInput;
